import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles.css";

export default function Stream() {
  return (
    <>
      <Navbar />
      <main>
        <section className="stream-hero">
          <div className="container">
            <h1>Live <span className="highlight">Stream</span></h1>
            <p>Join me live on Twitch for gaming, coding, and community fun</p>
          </div>
        </section>
        <section className="stream-section">
          <div className="container">
            <div className="stream-container">
              <div className="offline-message">
                <i className="fas fa-broadcast-tower"></i>
                <h2>Currently <span className="highlight">Offline</span></h2>
                <p>I'm not streaming right now, but check out the schedule below to see when I'll be back!</p>
                <p>In the meantime, you can watch my <a href="/videos">previous videos</a> or explore my <a href="/shop">streaming tools</a>.</p>
              </div>
              <div className="stream-info">
                <h2>About My <span className="highlight">Stream</span></h2>
                <p>Welcome to my Twitch channel! Here's what you can expect when you tune in:</p>
                <ul>
                  <li><strong>Gaming:</strong> I primarily play action RPGs, adventure, and the occasional indie title. While focusing on story games, I tend to not respond to messages during cutscenes or dialogues.</li>
                  <li><strong>Tool Development:</strong> While still learning coding, I enjoy creating tools for OBS and Streamer.bot. You can find them in the <a href="/shop"><span className="highlight">shop</span></a>.</li>
                  <li><strong>Chat Interaction:</strong> You'll sometimes hear a "Citizen" sound alert when someone chats. This helps me to know when someone joins in first time as I do tend to get distracted with the game I am playing.</li>
                </ul>
                <p>If you enjoy the stream, consider following or subscribing to support future content!</p>
              </div>

              <div className="stream-features">
                <h2 className="features-title">Stream Features &<span className="highlight"> Subscriber Benefits</span></h2>
                <div className="features-grid">
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fas fa-gem feature-icon" style={{color: '#ffb400'}}></i>
                      <h3>Channel Points</h3>
                    </div>
                    <p>Redeem channel points for fun on-stream interactions, sound effects, memes, and more!</p>
                  </div>
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fas fa-laugh-squint feature-icon" style={{color: '#ff5e57'}}></i>
                      <h3>Fun Commands</h3>
                    </div>
                    <p>Trigger meme sounds and alerts live on stream. Have fun with the community and surprise me!</p>
                  </div>
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fas fa-star feature-icon" style={{color: '#00eaff'}}></i>
                      <h3>Sub Perks</h3>
                    </div>
                    <p>Get Ad-free viewing, Exclusive emotes & badges, save up Channel Points by using Sub-only commands to play memes and access to all of my Premium tools!</p>
                  </div>
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fa-solid fa-gamepad feature-icon" style={{color: '#a259f7'}}></i>
                      <h3>Gameplay</h3>
                    </div>
                    <p>I live life in Hard mode, but I play in Easy mode. Perfectly balanced!</p>
                  </div>
                </div>
              </div>
              <div className="stream-schedule">
                <h2>Stream <span className="highlight">Schedule</span></h2>
                <p>Below is my stream schedule, please note that this is subject to change due to commitments with work and personal life.</p>
                <div className="schedule-grid">
                  <div className="schedule-item">
                    <div className="schedule-day">Tuesday</div>
                    <div className="schedule-game">Death Stranding: Director's Cut</div>
                    <div className="schedule-time">6:00PM (UK)</div>
                  </div>
                  <div className="schedule-item">
                    <div className="schedule-day">Thursday</div>
                    <div className="schedule-game">Death Stranding: Director's Cut</div>
                    <div className="schedule-time">6:00PM (UK)</div>
                  </div>
                  <div className="schedule-item">
                    <div className="schedule-day">Saturday</div>
                    <div className="schedule-game">Death Stranding: Director's Cut</div>
                    <div className="schedule-time">9:30AM (UK)</div>
                  </div>
                </div>
              </div>
              <div className="main-stream">
                <div id="twitch-embed"></div>
                {/* Twitch embed script */}
                <iframe
                  src="https://player.twitch.tv/?channel=zemaxi&parent=localhost&parent=zemaxi.com"
                  height="700"
                  width="100%"
                  allowFullScreen
                  frameBorder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}